import { UserClient } from "./user";

export class AuthClient {
    private worker: SharedWorker;
    public userClient: UserClient;

    private refreshRequest: Promise<any> | null = null;

    constructor(userClient: UserClient) {
      this.worker = new SharedWorker("/workers/auth.worker.js");
      this.userClient = userClient;
    }

    async authenticate() {
      await this.refresh(true);
      await this.userClient.getCurrentUser();
    }

    async refresh(force: boolean) {
      const apiKey = localStorage.getItem("apiKey");
      if (apiKey) {
        return;
      }

      if (this.refreshRequest && !force) {
        return await this.refreshRequest;
      }

      this.refreshRequest = new Promise((resolve) => {
        this.worker.port.onmessage = function(e) {
          resolve(e.data);
        };
      }).finally(() => { this.refreshRequest = null; });
      this.worker.port.postMessage({ force });

      const result = await this.refreshRequest;

      if (result.status === 401) {
        this.login();
        return Promise.reject("Refresh token has expired");
      }
    }

    private login() {
      window.location.replace("/api/auth/v1/authenticate");
    }

    public async logout() {
      this.worker.port.postMessage({ logout: true });
      this.login();
    }
}